import React, { useState, useEffect } from "react";
import axios from "axios";
import week1 from "../../assets/imageinfo/1.jpg";
import week2 from "../../assets/imageinfo/2.jpg";
import week3 from "../../assets/imageinfo/3.jpg";
import week4 from "../../assets/imageinfo/4.jpg";
import week5 from "../../assets/imageinfo/5.jpg";
import week6 from "../../assets/imageinfo/6.jpg";
import week7 from "../../assets/imageinfo/7.jpg";
import week8 from "../../assets/imageinfo/8.jpg";
import week9 from "../../assets/imageinfo/9.jpg";
import week10 from "../../assets/imageinfo/10.jpg";
import week11 from "../../assets/imageinfo/11.jpg";
import week12 from "../../assets/imageinfo/12.jpg";
import week13 from "../../assets/imageinfo/13.jpg";
import week14 from "../../assets/imageinfo/14.jpg";
import week15 from "../../assets/imageinfo/15.jpg";
import week16 from "../../assets/imageinfo/16.jpg";
import week17 from "../../assets/imageinfo/17.jpg";
import week18 from "../../assets/imageinfo/18.jpg";
import week19 from "../../assets/imageinfo/19.jpg";
import week20 from "../../assets/imageinfo/20.jpg";
import week21 from "../../assets/imageinfo/21.jpg";
import week22 from "../../assets/imageinfo/22.jpg";
import week23 from "../../assets/imageinfo/23.jpg";
import week24 from "../../assets/imageinfo/24.jpg";
import week25 from "../../assets/imageinfo/25.jpg";
import week26 from "../../assets/imageinfo/26.jpg";
import week27 from "../../assets/imageinfo/27.jpg";
import week28 from "../../assets/imageinfo/28.jpg";
import week29 from "../../assets/imageinfo/29.jpg";
import week30 from "../../assets/imageinfo/30.jpg";
import week31 from "../../assets/imageinfo/31.jpg";
import week32 from "../../assets/imageinfo/32.jpg";
import week33 from "../../assets/imageinfo/33.jpg";
import week34 from "../../assets/imageinfo/34.jpg";
import week35 from "../../assets/imageinfo/35.jpg";
import week36 from "../../assets/imageinfo/36.jpg";
import week37 from "../../assets/imageinfo/37.jpg";
import week38 from "../../assets/imageinfo/38.jpg";
import week39 from "../../assets/imageinfo/39.jpg";
import week40 from "../../assets/imageinfo/40.jpg";

import datas from "../../data/datas.json";
import { FaBaby, FaRuler, FaSeedling, FaWeight } from "react-icons/fa";

const Home3 = ({ weekNo, setWeekNo }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const localImages = {
    1: week1,
    2: week2,
    3: week3,
    4: week4,
    5: week5,
    6: week6,
    7: week7,
    8: week8,
    9: week9,
    10: week10,
    11: week11,
    12: week12,
    13: week13,
    14: week14,
    15: week15,
    16: week16,
    17: week17,
    18: week18,
    19: week19,
    20: week20,
    21: week21,
    22: week22,
    23: week23,
    24: week24,
    25: week25,
    26: week26,
    27: week27,
    28: week28,
    29: week29,
    30: week30,
    31: week31,
    32: week32,
    33: week33,
    34: week34,
    35: week35,
    36: week36,
    37: week37,
    38: week38,
    39: week39,
    40: week40,
  };

  const weekData = datas?.dimensions?.dimension?.find(
    (item) => Number(item.week) === weekNo
  );

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [response1, response2] = await Promise.all([
        axios.post("https://musicplayer.preggyzone.com/api/get_info", {
          info_type: 1,
          weekno: weekNo,
          is_image_show: 1,
        }),
        axios.post("https://musicplayer.preggyzone.com/api/get_info", {
          info_type: 2,
          weekno: weekNo,
          is_image_show: 1,
        }),
      ]);

      const weeks = response1.data.data || [];
      const weeks2 = response2.data.data || [];

      const resp1 = weeks
        .filter((el) => el.weekno === weekNo)
        .slice(0, 1)
        .map((el) => ({ ...el, type: "resp1" }));
      const resp2content = weeks2
        .filter((el) => el.weekno === weekNo)
        .map((el) => ({ ...el, type: "resp2" }));
      const resp2 = resp2content.filter((el) => el.is_image_show === 1);

      const localImageData =
        localImages[weekNo] !== undefined
          ? [
              {
                id: `local-${weekNo}`,
                img_url: localImages[weekNo],
                title: `Week ${weekNo}`,
                info_name: ` Baby Size - Week ${weekNo}`,
                info_description: "Your Baby Seems Like this fruit",

                type: "local",
              },
            ]
          : [];

      const combinedData = [...resp1, ...resp2, ...localImageData];

      setData(combinedData);
      setSelectedImage(combinedData.length > 0 ? combinedData[0].id : null);
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [weekNo]);

  const handleClick = (id) => {
    setSelectedImage(id);

    setTimeout(() => {
      const updatedData = [...data];
      const clickedImageIndex = updatedData.findIndex((item) => item.id === id);

      if (clickedImageIndex !== 1) {
        const temp = updatedData[1];
        updatedData[1] = updatedData[clickedImageIndex];
        updatedData[clickedImageIndex] = temp;
      }

      setData(updatedData);
      window.scrollBy({ top: 500, behavior: "smooth" });
    }, 300);
  };

  return (
    <div className="container-fluid text-center my-5 infos">
      <h2 className="mb-5" style={{ color: "#B24C76" }}>
        Pregnancy Info (Week {weekNo})
      </h2>

      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div className="laps">
          {data.map((item, index) => (
            <div key={item.id} onClick={() => handleClick(item.id)}>
              <img
                src={item.img_url}
                alt={item.info_description}
                id={`${index == 1 ? "abs" : "boss"}`}
                className={`rounded-circle ${
                  selectedImage === item.id ? "selected-image" : ""
                }`}
                style={{
                  objectFit: "cover",
                }}
              />
              <h2 className="heading">
                {item.type === "resp1" && "Mom Info"}
                {item.type === "resp2" && "Baby Info"}
                {item.type === "local" && "Size of the Baby"}
              </h2>
            </div>
          ))}
        </div>
      )}

      {weekData ? (
        <div className="week-info-box">
          {/* Shimmer Effect */}
          <div className="shimmer-bg"></div>

          <h4
            style={{
              fontSize: "22px",
              fontWeight: "600",
              letterSpacing: "1px",
              color: "black",
            }}
          >
            Week {weekNo}
          </h4>
          <hr style={{ color: "black", width: "100%", height: "10px" }} />
          <div className="info-row">
            <FaBaby className="icon" style={{ fontSize: "25px" }} />
            <span className="labell">Growth will be:</span>
            <span className="valuee">{weekData.fruit || "N/A"}</span>
          </div>
          <div className="info-row">
            <FaWeight className="icon" style={{ fontSize: "25px" }} />
            <span className="labell">Weight around:</span>
            <span className="valuee">{weekData.weight || "N/A"}</span>
          </div>
          <div className="info-row">
            <FaRuler className="icon" style={{ fontSize: "25px" }} />
            <span className="labell">At length of:</span>
            <span className="valuee" style={{ color: "black" }}>
              {weekData.length || "N/A"}
            </span>
          </div>
        </div>
      ) : (
        <p
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "#999",
            marginTop: "20px",
            textAlign: "center",
          }}
        >
          No data available for this week.
        </p>
      )}

      {selectedImage && (
        <div
          className="mt-4 full-width-content"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <div
            className={`content-container ${selectedImage ? "selected" : ""}`}
          >
            <h3>{data.find((item) => item.id === selectedImage)?.info_name}</h3>
            <p style={{ color: "grey", fontWeight: "400" }}>
              {data.find((item) => item.id === selectedImage)
                ?.info_description || "No additional content available"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home3;
